export const EXPERIMENT_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 180;

type PersistedCookieOptions = {
  maxAge: number;
  path: string;
  sameSite: 'lax' | 'none';
  secure: boolean;
};

function usesSecureCookies(): boolean {
  return (process.env.NEXT_PUBLIC_URL ?? '').startsWith('https://');
}

export function getPersistedCookieOptions(
  maxAge: number,
): PersistedCookieOptions {
  const secure = usesSecureCookies();

  return {
    maxAge,
    path: '/',
    secure,
    sameSite: secure ? 'none' : 'lax',
  };
}

export function getClientPersistedCookieOptions(
  maxAge: number,
): PersistedCookieOptions {
  const secure =
    typeof window !== 'undefined' && window.location.protocol === 'https:';

  return {
    maxAge,
    path: '/',
    secure,
    sameSite: secure ? 'none' : 'lax',
  };
}

export const EXPERIMENT_HEADER_PREFIX = 'x-experiment-';

export function getExperimentCookieName(name: string, version: number): string {
  return `abtest-${name}-v${version}`;
}

export function getExperimentHeaderName(name: string): string {
  return `${EXPERIMENT_HEADER_PREFIX}${name}`;
}

export function getExperimentUrlParamName(name: string): string {
  return `abtest-${name}`;
}

export function parseExperimentOverridesFromSearch(
  search: string,
): Record<string, string> {
  const params = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search,
  );
  const overrides: Record<string, string> = {};

  params.forEach((value, key) => {
    if (!key.startsWith('abtest-')) return;

    const rest = key.slice('abtest-'.length);
    const versionedMatch = /^(.+)-v(\d+)$/.exec(rest);
    overrides[versionedMatch ? versionedMatch[1] : rest] = value;
  });

  return overrides;
}
